// extracted by mini-css-extract-plugin
export var saApprenticeStepsContainer = "saSteps-module--saApprenticeStepsContainer--3pNpT";
export var saSectionTitleContainer = "saSteps-module--saSectionTitleContainer--1cL3V";
export var saSectionSubtitleContainer = "saSteps-module--saSectionSubtitleContainer--2yZiE";
export var saApprenticeSteps = "saSteps-module--saApprenticeSteps--1c7DL";
export var saStepItem = "saSteps-module--saStepItem--3fEbk";
export var saNum = "saSteps-module--saNum--zpeR8";
export var saTitle = "saSteps-module--saTitle--3dGnT";
export var saText = "saSteps-module--saText--3ZB3p";